module.exports = __webpack_public_path__ + "static/media/employee_efficiency-desktop.8c262aa2.png";